import constants from '@/constants.js';

export default {
    getSTPageLink: (key, id) => {
        switch (key.toLowerCase()) {
        case 'facebook':
            return constants.ST_PAGE_LINKS.FACEBOOK + id;
        case 'twitter':
            return constants.ST_PAGE_LINKS.TWITTER + id;
        case 'youtube':
            return constants.ST_PAGE_LINKS.YOUTUBE + id;
        case 'instagram':
            return constants.ST_PAGE_LINKS.INSTAGRAM + id;
        }
    }
};
